"use strict";

import $ from 'jquery';

const defaultSelectors = {
    base: '.js-number-spinner',
    input: '.js-number-spinner__input',
    upButton: '.js-number-spinner__up',
    downButton: '.js-number-spinner__down'
};

export function createInitInScope(selectors = defaultSelectors, defaultOptions) {
    return function ($scope) {
        let $numberSpinnerContainers = $scope.find(selectors.base);

        $numberSpinnerContainers.each(function () {
            let $spinner = $(this),
                $numberSpinnerInput = $spinner.find(selectors.input),
                $numberSpinnerUp = $spinner.find(selectors.upButton),
                $numberSpinnerDown = $spinner.find(selectors.downButton);

            let options = {...defaultOptions};

            if ($numberSpinnerInput.attr('min')) {
                options.min = +$numberSpinnerInput.attr('min');
            }

            if ($numberSpinnerInput.attr('max')) {
                options.max = +$numberSpinnerInput.attr('max');
            }

            $numberSpinnerUp.on('click', function (evt) {
                evt.preventDefault();
                let newValue = +$numberSpinnerInput.val() + 1;

                if (typeof options.max !== 'undefined') {
                    newValue = Math.min(+$numberSpinnerInput.val() + 1, options.max);
                }
                $numberSpinnerInput.val(newValue).change();
            });


            $numberSpinnerDown.on('click', function (evt) {
                evt.preventDefault();
                let newValue = +$numberSpinnerInput.val() - 1;

                if (typeof options.min !== 'undefined') {
                    newValue = Math.max(+$numberSpinnerInput.val() - 1, options.min);
                }

                $numberSpinnerInput.val(newValue).change();
            });

            $numberSpinnerInput.on('change', function (evt) {
                evt.preventDefault();
                let newValue = $numberSpinnerInput.val();

                if (typeof options.max !== 'undefined' && parseInt(newValue) > parseInt(options.max)) {
                    $numberSpinnerInput.val(options.max);
                } else if (typeof options.min !== 'undefined' && newValue < options.min) {
                    $numberSpinnerInput.val(options.min);
                }

                enableDisableButtons($spinner, options);
            });

            enableDisableButtons($spinner, options);

        });
    }
}

function enableDisableButtons($spinner, options) {
    if (!$spinner.is('.js-number-spinner')) {
        console.error('Can\'t en-/disable buttons for element', $spinner, 'Element is not a number spinner ".js-number-spinner"');
        return;
    }

    let $numberSpinnerInput = $spinner.find('.js-number-spinner__input');
    let $numberSpinnerUp = $spinner.find('.js-number-spinner__up');
    let $numberSpinnerDown = $spinner.find('.js-number-spinner__down');
    let $numberSpinnerInputVal = +$numberSpinnerInput.val();

    if (typeof options.max !== 'undefined') {
        if (options.max === $numberSpinnerInputVal) {
            $numberSpinnerUp.attr('disabled', 'disabled');
        } else {
            $numberSpinnerUp.attr('disabled', null);
        }
    }

    if (typeof options.min !== 'undefined') {
        if (options.min === $numberSpinnerInputVal) {
            $numberSpinnerDown.attr('disabled', 'disabled');
        } else {
            $numberSpinnerDown.attr('disabled', null);
        }
    }
}

export const initInScope = createInitInScope();
